export const FormScrollToOnStart = ({
  editMode,
  depth,
  typeProps,
  injectable,
  showPdfProps,
  title,
  ...props
}) => {
  const scrollToOnStartId = typeProps?.scrollToOnStartId || ''

  return <div id={scrollToOnStartId} />
}
